import {z} from 'zod';
import {UpdateEmailEvaluationRequest} from '../api/generated/index.defs';
import {mapNullToUndefined} from '../utils/zod';

export const emailEvaluationSchema = z.object({
  partnerSiteId: z.number(),
  filterOnEnteredByUserId: mapNullToUndefined(z.number().optional()),
  filterOnLevelOfServiceId: mapNullToUndefined(z.number().optional()),
  email: z.string().min(1, 'Field is required'),
  filterOnClientNamed: mapNullToUndefined(z.string().optional()),
  filterOnCanBeRepaired: mapNullToUndefined(z.string().optional()),
}) satisfies z.Schema<UpdateEmailEvaluationRequest>;

export type EmailEvaluationSchema = z.TypeOf<typeof emailEvaluationSchema>;